import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import img1 from "../images/blog-01.jpg";
import styles from "../style/BlogDetails.module.css";
import emailjs from "emailjs-com";

const BlogDetails = () => {
  const location = useLocation();
  const { blog } = location.state;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const commentsPerPage = 5;

  useEffect(() => {
    const fetchBlogs = async () => {
      await fetch(
        `https://book.swlancer.com/node/get_blog_comments?blog_id=${blog.blog_id}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          setComments(data);
        })
        .catch((error) => {
          console.error(
            "There was a problem with your fetch operation:",
            error
          );
        });
    };

    fetchBlogs();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !comment) {
      alert("Please fill in all required fields.");
      return;
    }
    // Check for special characters in the email and comment fields and name fields
    const specialCharacters = /[!#$%^&*(),.?":{}|<>]/;
    if (specialCharacters.test(name) || specialCharacters.test(comment)) {
      alert(
        "Name and comment fields are not allowed to contain special characters."
      );
      return;
    }

    // For Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch(
        `https://book.swlancer.com/node/insert_comment?blog_id=${blog.blog_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, email, comment }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }

      const result = await response.json();
      console.log("Comment inserted successfully:", result);
    } catch (error) {
      console.error("There was a problem with your fetch operation:", error);
      alert("Failed to submit the comment. Please try again.");
    }

    const templateParams = {
      Name: name,
      Email: email,
      Blog: blog.title,
      Comment: comment,
      Date: new Date().toDateString(),
      to_email: "mortadalb@gmail.com",
    };
    emailjs
      .send(
        "service_1d1bd5m", // EmailJS service ID
        "template_osatcch", // EmailJS template ID
        templateParams,
        "y2xE1Ok9l9lheSnoX" // EmailJS user ID (public key)
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Comment submitted successfully!");
        },
        (err) => {
          console.log("FAILED...", err);
          alert("Form submission failed. Please try again.");
        }
      );
    // Clear form fields
    setName("");
    setEmail("");
    setComment("");
  };

  // Calculate the current comments to display
  const indexOfLastComment = currentPage * commentsPerPage;
  const indexOfFirstComment = indexOfLastComment - commentsPerPage;
  const currentComments = comments.slice(
    indexOfFirstComment,
    indexOfLastComment
  );

  // Handle pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(comments.length / commentsPerPage); i++) {
    pageNumbers.push(i);
  }
  if (!blog) {
    return <div>Blog details not available</div>;
  }
  // Parse the description if it's a JSON string
  let description = blog.details;
  try {
    description = JSON.parse(blog.details);
    console.log(description);
  } catch (e) {
    console.error("Error parsing description:", e);
  }

  return (
    <div className={styles.blogDetails}>
      <img src={img1} alt={blog.title} className={styles.blogImage} />
      <p className={styles.blogDate}>{new Date(blog.date).toDateString()}</p>
      <h1 className={styles.blogTitle}>{blog.title}</h1>
      <p className={styles.blogDescription}>{description.description}</p>
      <div className={styles.comments}>
        <h2>Comments</h2>
        {currentComments && currentComments.length > 0 ? (
          currentComments.map((comment) => (
            <div key={comment.comment_id} className={styles.comment}>
              <p className={styles.date}>
                {new Date(blog.date).toLocaleDateString()}
              </p>
              <p className={styles.commentAuthor}>
                <strong>{comment.name}</strong>
              </p>
              <p className={styles.commentContent}>{comment.comment}</p>
            </div>
          ))
        ) : (
          <p>No comments available</p>
        )}
      </div>
      <div className={styles.pagination}>
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={styles.pageButton}
          >
            {number}
          </button>
        ))}
      </div>
      <div className={styles.commentForm}>
        <h2>Post a Comment</h2>
        <form onSubmit={handleSubmit} className={styles.commentForm}>
          <div className={styles.formGroup}>
            <textarea
              type="text"
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              required
              placeholder="Your Comment"
              rows={5}
            ></textarea>
          </div>
          <div className={styles.formGroupBox}>
            <div className={styles.formGroup}>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder="Your Name"
              />
            </div>
            <div className={styles.formGroup}>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Your Email"
              />
            </div>
          </div>
          <button type="submit" className={styles.submitButton}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default BlogDetails;
